import React from 'react';
import PropTypes from 'prop-types';
import { ForgeBadge } from '@tylertech/forge-react';
import { textCase } from '../../reusableFunctions.js';

const BadgeComponent = ({ main, theme }) => {
  return (
    <div style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
      {main && <ForgeBadge theme={theme}>{textCase(main)}</ForgeBadge>}
    </div>
  );
};

BadgeComponent.propTypes = {
  main: PropTypes.string,
  theme: PropTypes.string,
};
export default BadgeComponent;
